/**
 * Csv Schema of MotoristaResponsavel
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'

/* TODO: review generated schema */
export class CsvMotoristaResponsavelSchema extends Schema {
  readonly name = 'CsvMotoristaResponsavel'

  readonly fieldSet: FieldSet<MotoristaResponsavel> = {
    motorista: schema => schema.model.motorista?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    apelido: schema => schema.model.apelido,
  }
}
